import { createStore } from 'jotai';
import { atom } from 'jotai';

const snackbarStore = createStore();

const overlayAtom = atom(false);

export { snackbarStore, overlayAtom };